var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2492 0.915258C18.0377 1.12755 18.6594 1.74927 18.8717 2.5378C19.266 3.97837 19.2508 6.98083 19.2508 6.98083C19.2508 6.98083 19.2508 9.96813 18.8717 11.4087C18.6594 12.1972 18.0377 12.8189 17.2492 13.0312C15.8086 13.4103 10.0463 13.4103 10.0463 13.4103C10.0463 13.4103 4.29917 13.4103 2.84344 13.0161C2.05491 12.8038 1.43319 12.1821 1.2209 11.3935C0.841797 9.96813 0.841797 6.96567 0.841797 6.96567C0.841797 6.96567 0.841797 3.97837 1.2209 2.5378C1.43319 1.74927 2.07008 1.11239 2.84344 0.900094C4.28401 0.520996 10.0463 0.520996 10.0463 0.520996C10.0463 0.520996 15.8086 0.520996 17.2492 0.915258ZM13.004 6.86038L8.21218 9.62021V4.10054L13.004 6.86038Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b427c643035aa9949916d3c1abb383b2.svg";
export { ForwardRef as ReactComponent };